import GoogleLocation from "@/entities/common/google_location"
import BaseLogic from "../base_logic"
import FilialeLiefergebietResult from "@/entities/common/filiale_liefergebiet_result"
import { Lieferung } from "@/entities/common/bestellung_pending"
import router from "@/router"
import RouteNames from "@/util/route_names"
import BPLieferungStandortRequest from "@/entities/common/pending/bp_lieferung_standort_request"
import vuexStore from "@/store"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"
import LocationRequest from "@/entities/common/request/location_request"
import GoogleLocationList from "@/entities/common/lists/google_location_list"
import LatLonFilialeRequest from "@/entities/common/request/lat_lon_filiale_request"
import LatLonRequest from "@/entities/common/request/lat_lon_request"

export default class StandortLieferungLogic extends BaseLogic {
  insertError: boolean = false
  insertWorking: boolean = false

  locations: GoogleLocation[] = []
  _searchText: string = null
  _selectedLocation: GoogleLocation = null
  standort: string = null
  liefergebiet: FilialeLiefergebietResult = null
  l: Lieferung = null

  timerHandle: any = null
  timeout: number = 1000
  editMode: boolean = false

  init() {
    this.l = this.mainLogic.bestellungPending.lieferung

    this.mainLogic.bestellungPendingListeners.push(() => {
      this.l = this.mainLogic.bestellungPending.lieferung
    })
    // vuexStore.state.bestellungPending.lieferung
    this.editMode = this.l == null
  }

  weiterDirekt() {
    if (this.mainLogic.filiale.lieferungSettings.supportsTermin) {
      router.push({ name: RouteNames.NEU.TERMIN_LIEFERUNG })
    } else {
      router.push({ name: RouteNames.NEU.SHOPPING_LIEFERUNG.PRODUKTE })
    }
  }

  weiter() {
    this.insertWorking = true
    this.insertError = false

    var request = new BPLieferungStandortRequest()
    request.id = vuexStore.state.user.identifier
    // request.id = this.mainLogic.bestellungPending.id
    request.liefergebietId = this.liefergebiet.liefergebietId
    request.strasse =
      this._selectedLocation.strasse + " " + this._selectedLocation.strasseNr
    request.plz = this._selectedLocation.plz
    request.ort = this._selectedLocation.stadt

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingLieferungStandort,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this.mainLogic.bestellungPending.lieferung.liefergebietId =
            this.liefergebiet.liefergebietId
          this.mainLogic.bestellungPending.lieferung.lieferkosten =
            this.liefergebiet.lieferkosten
          this.mainLogic.bestellungPending.lieferung.mindestbestellwert =
            this.liefergebiet.mindestbestellwert
          this.mainLogic.bestellungPending.lieferung.kundeStrasse =
            this._selectedLocation.strasse +
            " " +
            this._selectedLocation.strasseNr
          this.mainLogic.bestellungPending.lieferung.kundePlz =
            this._selectedLocation.plz
          this.mainLogic.bestellungPending.lieferung.kundeOrt =
            this._selectedLocation.stadt
          this.mainLogic.bestellungPending.lieferung.kostenlosAb =
            this.liefergebiet.kostenlosAb

          if (this.mainLogic.filiale.lieferungSettings.supportsTermin) {
            router.push({ name: RouteNames.NEU.TERMIN_LIEFERUNG })
          } else {
            router.push({ name: RouteNames.NEU.SHOPPING_LIEFERUNG.PRODUKTE })
          }
        } else {
          this.insertError = true
        }
      })
      .catch(() => {
        this.insertWorking = false
        this.insertError = true
      })
  }

  standortBearbeiten() {
    this.editMode = true
  }

  get searchText(): string {
    return this._searchText
  }

  set searchText(newValue: string) {
    this._searchText = newValue
    this.timeout = 1000

    if (!this.timerHandle) {
      this.timerHandle = setInterval(() => {
        this.timeout = this.timeout - 200

        if (this.timeout <= 0) {
          clearInterval(this.timerHandle)
          this.timerHandle = null
          this.timeout = 1000

          if (this._searchText.length >= 3) {
            var request = new LocationRequest()
            request.locationString = this._searchText

            Poster.postMember<RemoteResult<GoogleLocationList>>(
              RestPaths.locationListByTextOSM,
              request
            ).then((response) => {
              if (response.data.success) {
                this.locations = []
                response.data.payload.list.forEach((element) => {
                  this.editLocation(element)
                  this.locations.push(element)
                })
              }
            })
          }
        }
      }, 200)
    }
  }

  get selectedLocation(): GoogleLocation {
    return this._selectedLocation
  }

  set selectedLocation(newValue: GoogleLocation) {
    this._selectedLocation = newValue

    // var updateStandort = {
    //   bezeichnung: this._selectedLocation.bezeichnung,
    //   land: this._selectedLocation.land,
    //   plz: this._selectedLocation.plz,
    //   ort: this._selectedLocation.stadt,
    //   strasse:
    //     this._selectedLocation.strasse + " " + this.selectedLocation.strasseNr,
    //   latitude: this._selectedLocation.latitude,
    //   longitude: this._selectedLocation.longitude,
    // }

    this.standort = this._selectedLocation.bezeichnung

    var mlStandort = this.mainLogic.standort
    mlStandort.bezeichnung = this._selectedLocation.bezeichnung
    mlStandort.latitude = this._selectedLocation.latitude
    mlStandort.longitude = this._selectedLocation.longitude
    mlStandort.land = this._selectedLocation.land
    mlStandort.plz = this._selectedLocation.plz
    mlStandort.ort = this._selectedLocation.stadt
    mlStandort.strasse =
      this._selectedLocation.strasse + " " + this.selectedLocation.strasseNr

    //vuexStore.commit(StoreOps.UPDATE_STANDORT, updateStandort)

    var request = new LatLonFilialeRequest()
    request.filialeId = this.mainLogic.filiale.filialeId
    request.latitude = this._selectedLocation.latitude
    request.longitude = this._selectedLocation.longitude

    Poster.postUser<RemoteResult<FilialeLiefergebietResult>>(
      RestPaths.filialeLiefergebietStandort,
      request
    ).then((response) => {
      if (response.data.success) {
        this.liefergebiet = response.data.payload
      }
    })
  }

  editLocation(l: GoogleLocation) {
    var b = ""
    if (l.strasse) b += l.strasse + " "
    if (l.strasseNr) b += l.strasseNr + ", "
    if (l.plz) b += l.plz + " "
    if (l.stadt) b += l.stadt + ", "
    if (l.land) b += l.land
    l.bezeichnung = b
  }

  positionErmitteln(navigator: Navigator) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        const lat = pos.coords.latitude
        const lon = pos.coords.longitude

        var request = new LatLonRequest()
        request.latitude = lat
        request.longitude = lon

        Poster.postUser<RemoteResult<GoogleLocation>>(
          RestPaths.locationLocationByCoordinatesOSM,
          request
        ).then((response) => {
          var l = response.data.payload
          this.editLocation(l)
          this.selectedLocation = l
        })
      })
    }
  }
}
